import { RequestService } from '../../../../../common/services/RequestService';
import { CONDITIONERS_GET } from '../../constants';

export const getConditionersRequest = payload => {
  return RequestService.get(CONDITIONERS_GET);
};
